import React from "react";
import { useParams } from "react-router-dom";
import ConfirmWrapperArea from "./ConfirmWrapperArea";

function Confirm() {

  const { ctype } = useParams(); // mode will be "online" or "onsite"
  const { hash } = useParams(); // hash is the unique booking hash

  return (
    <>
      <ConfirmWrapperArea ctype={ctype} hash={hash} />
    </>
  );
}

export default Confirm;
